import { Directive } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[aza-rws-table-no-data-template]',
    standalone: false,
})
export class TableNoDataDirective {}
